import * as React from 'react';
import { InView } from 'react-intersection-observer';
import { pushImageGalleryItemClickEvent } from '../../../Analytics/events/ImageGalleryEvents.js';
import { useImageSlider } from '../hooks/use-image-slider.js';
import { HorizontalImageSlider } from '../HorizontalImageSlider/HorizontalImageSlider.js';
import { ProductImage } from '../ProductImage/ProductImage.js';
import { VtoBanner } from '../VtoBanner/VtoBanner.js';
import { ZoomModal } from '../ZoomModal/ZoomModal.js';
import { DittoContainer } from '../../../VTO/Ditto/components/DittoContainer/DittoContainer.js';

const ProductImageGalleryMobile = ({ images , imageParams , isVtoEnabled , setVtoActive , vtoActive , sku , vtoBanner , handleImageInteraction , zoomModalOpenIndex ,  })=>{
    const { setSlide , activeIndex , handleInView  } = useImageSlider(images.length, {
        elementIdentifierString: 'mobile__image-scroll-item'
    });
    const activeImage1 = images[activeIndex];
    // when vto is activated make sure the gallery switches to the vto slide
    React.useEffect(()=>{
        if (vtoActive && !activeImage1.vto) {
            setSlide(images.findIndex((image)=>image.vto
            ));
        }
    }, [
        images,
        vtoActive
    ]);
    const handleThumbnailClick = React.useCallback((thumbnail)=>{
        const activeImage = images.findIndex((image)=>image.label === thumbnail.label
        );
        setSlide(activeImage);
        sku && pushImageGalleryItemClickEvent(activeImage, sku, thumbnail);
    }, [
        images,
        setSlide
    ]);
    if (!Boolean(images.length)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("section", {
        className: "product-image-gallery-mobile"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-image-gallery-mobile__images"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-image-gallery-mobile__wrapper"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-image-gallery-mobile__image-scroller"
    }, images.map((image, index)=>/*#__PURE__*/ React.createElement(InView, {
            key: image.label,
            threshold: 0.8,
            onChange: (inView)=>handleInView(inView, index)
        }, ({ ref  })=>/*#__PURE__*/ React.createElement("div", {
                ref: ref,
                id: `mobile__image-scroll-item-${index}`,
                className: `product-image-gallery-mobile__image-scroller-item`
            }, image.vto && isVtoEnabled && !vtoActive && vtoBanner && /*#__PURE__*/ React.createElement(VtoBanner, {
                altText: image.altText,
                imageUrl: image.url,
                imageParams: imageParams,
                vtoBanner: vtoBanner,
                onClick: ()=>setVtoActive(true)
            }), image.vto && vtoActive && isVtoEnabled && !!sku && /*#__PURE__*/ React.createElement(DittoContainer, {
                sku: sku,
                vtoBanner: vtoBanner,
                onClose: ()=>setVtoActive(false)
            }), !image.vto && /*#__PURE__*/ React.createElement(ProductImage, {
                altText: image.altText,
                imageUrl: image.url,
                imageParams: imageParams,
                onClick: ()=>handleImageInteraction(index)
            }))
        )
    ))), images.length > 1 && /*#__PURE__*/ React.createElement("div", {
        className: "product-image-gallery-mobile__thumbnails",
        "data-t": "image-gallery-mobile__thumbnails"
    }, /*#__PURE__*/ React.createElement(HorizontalImageSlider, {
        images: images,
        onClick: handleThumbnailClick,
        activeImage: activeImage1
    }))), /*#__PURE__*/ React.createElement(ZoomModal, {
        isOpen: zoomModalOpenIndex !== null,
        openingIndex: activeIndex,
        onClose: ()=>handleImageInteraction(null)
        ,
        images: images
    }));
};

export { ProductImageGalleryMobile, ProductImageGalleryMobile as default };
//# sourceMappingURL=ProductImageGalleryMobile.js.map
